import classNames from 'classnames';
import * as React from 'react';

import { FormInputValidationIssues } from './FormInputValidationIssues';
import { FormField, FormFields, ValidationIssue } from './FormInterfaces';
import { getErrorId } from './GetErrorId';
import { isInputDisabled } from './GetValidationIssue';

export interface CheckboxInputProps {
    readonly value: boolean;
    readonly input: FormField;
    readonly inputs: FormFields;
    readonly name: string;
    readonly onChange: (value: boolean, name: string, errors: ValidationIssue[]) => void;
}

export const CheckboxInput = (props: CheckboxInputProps) => {
    if (props.input.type !== 'checkbox') throw new Error('Input Type Error');

    const changeValue = (value: boolean) => {
        props.onChange(value, props.name, []);
    };

    return (
        <div className={classNames('NewForm__FieldWrapper', isInputDisabled(props.input, props.inputs) && 'NewForm__FieldWrapper--Disabled')}>
            <div className="NewForm__Field">
                <label htmlFor={props.name}>
                    {props.input.displayName}
                    <span className="NewForm__FieldRequired">{props.input.validation?.required?.value && ' *'}</span>
                </label>
                <input
                    disabled={!!props.input.disabled}
                    id={props.name}
                    aria-invalid={props.input.validationIssues && props.input.wasActive}
                    aria-describedby={props.input.validationIssues && props.input.wasActive ? getErrorId(props.input.displayName) : undefined}
                    onChange={(e) => changeValue(e.target.checked)}
                    value={(props.input.value as boolean)?.toString() || false.toString()}
                    type={props.input.type}
                    autoComplete={props.input.autocomplete}
                />
            </div>
            <FormInputValidationIssues validationIssue={props.input.validationIssues} />
        </div>
    );
};
